import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Provider } from 'react-redux'
import toast, { Toaster } from 'react-hot-toast'
import store from './store/index'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
    <Toaster toastOptions={{
      position: 'top-right',
      style: {
        background: 'white',
        color: 'black'
      }
    }} />
  </Provider>
);

serviceWorkerRegistration.register({
  onUpdate: (reg) => {
    toast(
      (t) => (
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium">New version available!</span>
          <button
            onClick={() => {
              toast.dismiss(t.id)
              if (reg && reg.waiting) {
                reg.waiting.postMessage({ type: 'SKIP_WAITING' })
              }
              window.location.reload()
            }}
            className="bg-black text-white text-xs px-3 py-1 rounded-full font-medium hover:bg-gray-800"
          >
            Refresh
          </button>
        </div>
      ),
      { duration: Infinity, id: 'sw-update' }
    )
  }
});
reportWebVitals();
